'use strict';

//função chamada pelo chat da neurologic quando o lead é integrado com sucesso com nosso webhook
function nldAPI_JornalDoCarro_SendEvents(apiResponse) {

  if (apiResponse.hasOwnProperty('lead_id')) {
    //dispara eventos de envio de leads de oferta
    send_offer_lead_success_events(jQuery('.jc-offer-header').data('id'), apiResponse.lead_id, 'Oferta - Chat');
  }
}